import axiosInstance from './axiosInstance';

const knowledgeService = {
  getKnowledgeTree: async (level) => {
    const params = level ? { level } : {};
    const response = await axiosInstance.get('/knowledge/tree', { params });
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: Array.isArray(response.data) ? response.data : (response.data.data || [])
    };
  },

  getKnowledge: async (id) => {
    const response = await axiosInstance.get(`/knowledge/${id}`);
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: response.data.data || response.data
    };
  },

  getChildren: async (parentId) => {
    const response = await axiosInstance.get(`/knowledge/${parentId}/children`);
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: response.data.data || []
    };
  },

  createKnowledge: async (data) => {
    const response = await axiosInstance.post('/knowledge', data);
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: response.data.data || response.data
    };
  },

  updateKnowledge: async (id, data) => {
    const response = await axiosInstance.put(`/knowledge/${id}`, data);
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: response.data.data || response.data
    };
  },

  deleteKnowledge: async (id) => {
    const response = await axiosInstance.delete(`/knowledge/${id}`);
    return {
      code: response.data.code || 0,
      message: response.data.message || '',
      data: response.data.data || response.data
    };
  },
};

export default knowledgeService; 